import type { ProductGroupBidDto } from "../../autogen/bff-api";

export interface PricedProductGroup {
  id: string;
  products: { id: string; quantity: { value?: number | null } }[];
}

// Mirrors ProductBidPricing on the BFF — keep the two in step.
export const productBidTotal = (
  groups: PricedProductGroup[],
  bidProducts: ProductGroupBidDto[] | null | undefined,
): number | null => {
  const lineTotals = groups.flatMap((group) => {
    const groupBid = (bidProducts ?? []).find((g) => g.productGroupId === group.id);
    if (!groupBid) return [];
    return group.products.flatMap((product) => {
      const unitPrice = groupBid.productBids.find((p) => p.productId === product.id)?.unitPrice?.value;
      return unitPrice != null ? [(product.quantity.value ?? 1) * unitPrice] : [];
    });
  });
  return lineTotals.length > 0 ? lineTotals.reduce((sum, line) => sum + line, 0) : null;
};
